import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import React from 'react';
import { Checkboxes } from 'mui-rff';
import { stringToBoolean } from 'utils/common';
import {
  ADM_FORMAT,
  publisherContentCategory,
  RTB_PROTOCOL_VERSIONS,
} from '../../../../constants';

export const RadioAdapterIntegrationType = ({ input, ...rest }) => {
  return (
    <FormControl disabled>
      <FormLabel id='integrationType'>Integration type</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='integrationType'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='RTB' control={<Radio />} label='RTB' />
        <FormControlLabel value='DIRECT' control={<Radio />} label='DIRECT' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterRtbAdType = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='adType'>Endpoint ad type</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='adType'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='BANNER' control={<Radio />} label='BANNER' />
        <FormControlLabel value='NATIVE' control={<Radio />} label='NATIVE' />
        <FormControlLabel value='VIDEO' control={<Radio />} label='VIDEO' />
        <FormControlLabel value='POP' control={<Radio />} label='POP' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterProtocol = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      disabled={disabled}
      error={touched && !!error}
    >
      <FormLabel id='protocol'>Protocol</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='protocol'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='oRTB' control={<Radio />} label='oRTB' />
        <FormControlLabel value='XML' control={<Radio />} label='XML/JSON' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterAdvancedOptions = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isAdvanced'>Advanced options</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='isAdvanced'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value={false} control={<Radio />} label='HIDE' />
        <FormControlLabel value control={<Radio />} label='SHOW' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterAdType = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='adType'>Endpoint ad type</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='adType'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='PUSH' control={<Radio />} label='PUSH' />
        <FormControlLabel value='POP' control={<Radio />} label='POP' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterTrafficType = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='trafficType'>Inventory type</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='trafficType'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='ALL' control={<Radio />} label='ALL' />
        <FormControlLabel value='WEB' control={<Radio />} label='WEB' />
        <FormControlLabel value='IN APP' control={<Radio />} label='IN APP' />
      </RadioGroup>
    </FormControl>
  );
};
export const RadioAdapterContentCategoryType = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='publisherContentType'>Category</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='category'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        {Object.values(publisherContentCategory).map((val) => (
          <FormControlLabel
            control={<Radio />}
            label={val}
            value={val}
            key={val}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterAuctionType = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='auctionType'>Auction type</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='auctionType'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='ALL' control={<Radio />} label='ALL' />
        <FormControlLabel
          value='FIRST PRICE'
          control={<Radio />}
          label='FIRST PRICE'
        />
        <FormControlLabel
          value='SECOND PRICE'
          control={<Radio />}
          label='SECOND PRICE'
        />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterPaymentsWith = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='paymentsWith'>Calculate payout with</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='paymentsWith'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value='adm' control={<Radio />} label='ADM' />
        <FormControlLabel value='nurl' control={<Radio />} label='NURL' />
        <FormControlLabel value='burl' control={<Radio />} label='BURL' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterHtmlFormat = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isHtmlFormat'>ADM format</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isHtmlFormat'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel value control={<Radio />} label='HTML' />
        <FormControlLabel value={false} control={<Radio />} label='XML' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterGateway = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isGateway'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel
          value={false}
          control={<Radio />}
          label='Manual Integration'
        />
        <FormControlLabel value control={<Radio />} label='Gateway' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterValidationDefault = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isValidationDefault'>Validation</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isValidationDefault'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='true' control={<Radio />} label='Default' />
        <FormControlLabel value='false' control={<Radio />} label='Custom' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterMismatchParams = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isAllowMismatch'>
        Allow impression mismatch parameters
      </FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isAllowMismatch'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Off' />
        <FormControlLabel value='true' control={<Radio />} label='On' />
      </RadioGroup>
      {stringToBoolean(input.value) ? (
        <Checkboxes
          name='allowMismatch'
          data={[
            { label: 'IP', value: 'isAllowIp' },
            { label: 'IP Last octet', value: 'isAllowIpLastOctet' },
            { label: 'Geo', value: 'isAllowGeo' },
            { label: 'Device', value: 'isAllowDevice' },
            { label: 'Browser', value: 'isAllowBrowser' },
            { label: 'Browser version', value: 'isAllowBrowserVersion' },
            { label: 'OS', value: 'isAllowOs' },
            { label: 'OS version', value: 'isAllowOsVersion' },
            { label: 'User Agent', value: 'isAllowUa' },
          ]}
        />
      ) : null}
    </FormControl>
  );
};

export const RadioAdapterImpDuplicates = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isAllowImpDuplicates'>
        Allow impressions duplicates
      </FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isAllowImpDuplicates'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterFilterMaskedIP = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isFilterMaskedIP'>Filter masked IPS</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isFilterMaskedIP'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterLookupUserId = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isLookupUserId'>Lookup user by user.id</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isLookupUserId'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterSkipCreativeSize = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isSkipCreativeSize'>Skip creative size matching</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isSkipCreativeSize'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterAllowClickMismatch = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isAllowClickMismatch'>
        Allow click mismatch parameters
      </FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isAllowClickMismatch'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Off' />
        <FormControlLabel value='true' control={<Radio />} label='On' />
      </RadioGroup>
      {stringToBoolean(input.value) ? (
        <Checkboxes
          name='allowClickMismatch'
          data={[
            { label: 'IP', value: 'isAllowClickIp' },
            { label: 'IP Last octet', value: 'isAllowClickIpLastOctet' },
            { label: 'Geo', value: 'isAllowClickGeo' },
            { label: 'Device', value: 'isAllowClickDevice' },
            { label: 'Browser', value: 'isAllowClickBrowser' },
            { label: 'Browser version', value: 'isAllowClickBrowserVersion' },
            { label: 'OS', value: 'isAllowClickOs' },
            { label: 'OS version', value: 'isAllowClickOsVersion' },
            { label: 'User Agent', value: 'isAllowClickUa' },
          ]}
        />
      ) : null}
    </FormControl>
  );
};

export const RadioAdapterClickDuplicates = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isAllowClickDuplicates'>Allow clicks duplicates</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isAllowClickDuplicates'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterClickWithoutImpRule = ({
  input,
  meta,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isClickWithoutImpRule2'>
        Clicks without impressions
      </FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isClickWithoutImpRule2'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterAdmFormat = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='admFormat'>ADM format</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='admFormat'
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        <FormControlLabel
          value={ADM_FORMAT.vast_3_0}
          control={<Radio />}
          label='VAST 3.0'
        />
        <FormControlLabel
          value={ADM_FORMAT.json}
          control={<Radio />}
          label='JSON'
        />
      </RadioGroup>
    </FormControl>
  );
};

export const RadioAdapterCapPubUID = ({ input, meta, disabled, ...rest }) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='isCapPubUID'>Cap per Publisher User ID</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name='isCapPubUID'
        value={input.value}
        onChange={(event, value) => input.onChange(value === 'true')}
      >
        <FormControlLabel value='false' control={<Radio />} label='Disable' />
        <FormControlLabel value='true' control={<Radio />} label='Enable' />
      </RadioGroup>
    </FormControl>
  );
};

const RTB_LABELS_MAP = {
  [RTB_PROTOCOL_VERSIONS.AUTO]: 'Auto',
  [RTB_PROTOCOL_VERSIONS.EXO]: 'Exo',
};
export const RadioAdapterRTBVersion = ({
  input,
  meta,
  name,
  disabled,
  ...rest
}) => {
  const { touched, error } = meta;
  return (
    <FormControl
      component='fieldset'
      error={touched && !!error}
      disabled={disabled}
    >
      <FormLabel id='oRTBVersion'>Response Format</FormLabel>
      <RadioGroup
        {...rest}
        row
        aria-labelledby='row-radio-buttons-group-label'
        name={name}
        value={input.value}
        onChange={(event, value) => input.onChange(value)}
      >
        {Object.values(RTB_PROTOCOL_VERSIONS).map((val) => (
          <FormControlLabel
            key={val}
            value={val}
            control={<Radio />}
            label={RTB_LABELS_MAP[val]}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
